"use strict";

/**
 * 字符串截取
 * @param str
 * @param length
 * @returns {string}
 */
module.exports = function (str, length) {
  if (!str) return "";
  return str.length <= length ? str : str.substr(0, length - 1) + '...';
};